const DEFAULT_OPTIONS = {light: "black", dark: "white", threshold: 0.8};

export const getReadableTextColor = (backgroundColor, options = DEFAULT_OPTIONS) => {
  const {light, dark, threshold} = {...DEFAULT_OPTIONS, ...(options ?? {})};

  if (!backgroundColor || backgroundColor === "transparent" || !backgroundColor.startsWith("#")) return "#000000";

  const hexToRgb = hex => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return {r, g, b};
  };

  const calculateLuminance = ({r, g, b}) => {
    const [rNorm, gNorm, bNorm] = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rNorm + 0.7152 * gNorm + 0.0722 * bNorm;
  };

  const rgb = hexToRgb(backgroundColor);
  const luminance = calculateLuminance(rgb);

  return luminance > threshold ? light : dark;
};
